import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import CurrencyTable from '../../components/CurrencyTable/CurrencyTable';
import { getCurrencyRequestAction } from '../../store/currency/currencyActions';
import { useTranslation } from '../../hooks/useTranslation'

const Currency = ({ currencyList, getCurrencyRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    getCurrencyRequest({});
  }, [getCurrencyRequest]);

  const handleCreate = () => {
    navigate('/currency/create');
  };

  return (
    <div className="currency-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('currencies')}</div>
        <CurrencyTable currencyList={currencyList} />
      </CContainer>

      <CButton color="primary" className="create-order-fab" onClick={handleCreate}>
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currencyList: state.currencyReducer.currencyList || [],
});

const mapDispatchToProps = {
  getCurrencyRequest: getCurrencyRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Currency);
